import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendAnalystViewSampleWithInstanceAndSpec,
	FrontendCompanyWithAdditionalInfomation,
	FrontendCompanyTestCategory,
	FrontendCompanyTestHierarchyNode,
} from "node-library/dist/portal";
import { Card, Divider } from "@mui/material";
import { OrderTableSortColumn, SortOrder } from "node-library/dist/paginations";
import { NeutralColor } from "node-library/dist/colors";
import { FrontendContentPage } from "node-library/dist/constants";
import AnalystViewInstanceRow from "./analystViewInstanceRow";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	selectedCategory: FrontendCompanyTestCategory;
	instances: Array<FrontendAnalystViewSampleWithInstanceAndSpec>;
	user: FrontendUserInfo | undefined;

	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;

	navigateToInstanceDetailsPage: (
		instanceId: string,
		fromPage: FrontendContentPage
	) => void;
}

export default function AnalystViewInstancesTableListView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		instances,
		company,
		selectedCategory,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		user,
		navigateToInstanceDetailsPage,
	} = props;

	const hierarchyNodeParentMap = new Map<
		string,
		FrontendCompanyTestHierarchyNode[]
	>();

	selectedCategory.hierarchyNodes.forEach((node) => {
		const parentId = node.parentNodeId || "root";
		if (!hierarchyNodeParentMap.has(parentId))
			hierarchyNodeParentMap.set(parentId, [node]);
		else {
			hierarchyNodeParentMap.get(parentId)!.push(node);
		}
	});

	const headerItems = [
		{
			title: translation("Instances"),
		},
		{
			title: translation("Matrix"),
		},
		{
			title: translation("Tests"),
		},

		{
			title: translation("DueDate"),
		},
		{
			title: translation("Status"),
		},
		{
			title: translation("Action"),
		},
	];

	const instanceRows: Array<React.ReactNode> = instances
		? instances.map(
				(
					instance: FrontendAnalystViewSampleWithInstanceAndSpec,
					index: number
				) => {
					return (
						<AnalystViewInstanceRow
							key={instance.sampleInstanceId}
							testCategory={selectedCategory}
							hierarchyNodeParentMap={hierarchyNodeParentMap}
							instance={instance}
							user={props.user}
							goToViewInstanceDetails={() => {
								navigateToInstanceDetailsPage(
									instance.sampleInstanceId,
									FrontendContentPage.INSTANCE_PAGE
								);
							}}
						/>
					);
				}
		  )
		: [];

	const headerRowItems: React.ReactNode = headerItems.map((item) => {
		return (
			<div key={item.title} style={{ display: "flex", gap: "10px" }}>
				<Divider orientation="vertical" flexItem></Divider>
				<div
					className="typography-body-01"
					style={{
						color: NeutralColor.NEUTRAL_GREY_500,
						display: "flex",
						alignItems: "center",
						gap: "5px",
					}}
				>
					{item.title}
					{/* {item.sortColumnBy && (
						<SortArrowIcon
							sortOrder={sortOrder}
							notInUse={sortBy !== item.sortColumnBy}
						/>
					)} */}
				</div>
			</div>
		);
	});

	const instanceRowContainer: React.ReactNode = (
		<Card className="common-card card-medium-padding">{instanceRows}</Card>
	);

	return (
		<div>
			<div className=" instance-list-view-row instance-list-view-header">
				{headerRowItems}
			</div>
			{instanceRowContainer}
		</div>
	);
}
